module.exports = __webpack_public_path__ + "static/img/7.b081b09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/7.jpg
// module id = Ge1L
// module chunks = 4